// @flow

import styled from 'styled-components';

import cinematicRevealVerticalKeyframes from '../../../keyframes/cinematicRevealVerticalKeyframes';

export default styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  width: 100%;
  margin-top: ${props => (props.noMargin ? 0 : '20px')};
  opacity: 0;
  animation: ${cinematicRevealVerticalKeyframes} 0.4s ease-in-out;
  animation-delay: ${props => props.delay}s;
  animation-fill-mode: forwards;
  margin-bottom: 16px;
`;
